import { DotLoading, List, Modal, Popup, Tag } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import { momentDate, timeTableDayFromNumber } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import $ from "jquery";
import { Toast } from "antd-mobile";

const LeaveSubstitute = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name"
  );

  const [loader, setLoader] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [hoursData, setHoursData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [totalDates, setTotalDates] = useState([]);

  const getAttendanceDate = () => {
    if (props.timeTableDate) return props.timeTableDate;
    let x = context.getStorage("mob_attendance_date");
    return x && x != null ? x : momentDate(new Date(), "YYYY-MM-DD");
  };

  const [attendanceDate, setAttendaceDate] = useState(getAttendanceDate());
  const [totalDays, setTotalDays] = useState(0);

  useEffect(() => {
    var date1 = new Date(props.fromDate);
    var date2 = new Date(props.toDate);
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24) + 1;
    let datesArray = getDatesBetween(props.fromDate, props.toDate);
    setTotalDates(datesArray);
    setTotalDays(Difference_In_Days);
    loadData();
  }, [props]);

  const loadData = () => {
    setLoader(true);
    setSubjectData([]);
    setStaffList([]);
    const form = new FormData();
    let datesArray = getDatesBetween(props.fromDate, props.toDate);
    form.append("type", "today");
    form.append("date", momentDate(new Date(), "YYYY-MM-DD")); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("fromDate", props.fromDate); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("toDate", props.toDate); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("dayarray", datesArray); //momentDate(new Date(), "YYYY-MM-DD"));
    form.append("day", props.day);
    form.append("course", context.user.emp_academic_department);
    form.append("with_general", props.withGeneral ? "1" : "0");
    form.append(
      "staff_availability_relevant_hours",
      context.settingValue("staff_availability_relevant_hours")
    );
    axios.post(ServiceUrl.MOB.TIME_TABLE_FOR_SUBSTITUTE, form).then((res) => {
      if (res["data"].status == "1") {
        setSubjectData(res["data"].data);
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (selectedDate && selectedDate.length > 2) {
      context.setStorage("mob_attendance_date", selectedDate);
      setAttendaceDate(selectedDate);
    }
    Modal.clear();
  }, [selectedDate]);

  function getFormData() {
    const form = document.querySelector("#substitudeDetails");
    const formData = new FormData(form);
    const jsonObject = {};

    formData.forEach((value, key) => {
      if (key.endsWith("[]")) {
        // Handle array inputs
        const baseKey = key.slice(0, -2);
        if (!jsonObject[baseKey]) {
          jsonObject[baseKey] = [];
        }
        jsonObject[baseKey].push(value);
      } else {
        // Handle normal inputs
        jsonObject[key] = value;
      }
    });

    return jsonObject;
  }

  function getDatesBetween(startDate, endDate) {
    // Parse the start and end dates
    let start = new Date(startDate);
    let end = new Date(endDate);

    // Create an array to hold the dates
    let dateArray = [];

    // Iterate through each day between the start and end dates
    while (start <= end) {
      // Format the date as a string and push it to the array
      dateArray.push(start.toISOString().split("T")[0]);
      // Increment the date by one day
      start.setDate(start.getDate() + 1);
    }

    return dateArray;
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const selects = document.querySelectorAll("select");
    let isValid = true;

    selects.forEach((select) => {
      if (select.value === "") {
        select.classList.add("error");
        isValid = false;
      } else {
        select.classList.remove("error");
        isValid = true;
      }
    });

    if (!isValid) {
      Toast.show({
        content: "Please make sure all selections are filled out.",
      });
      return;
    }

    const formData = getFormData();
    props.onSuccess(formData);
  };

  function updateNextDropdown(e, next, prediv) {
    if (e.value === "") {
      e.classList.add("error");
    } else {
      // e.classList.remove("error");
    }

    var nextDropdown = $("#" + next)
      .next("#staff")
      .find("select");

    if (nextDropdown.length) {
      nextDropdown.find("option").each(function () {
        if ($(this).val() == e.value) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    }
  }
  let j = 1;
  return (
    <>
      <div
        data-aos="zoom-in"
        className="section-heading d-flex align-items-center justify-content-between rtl-flex-d-row-r px-2"
        style={{
          backgroundColor: "#ff443a",
          border: "1px solid #ccc",
          borderRadius: "15px",
          height: "55px",
          color: "#FFF",

          /*   marginTop: "-8%", */
        }}
      >
        <h6
          className="text-uppercase"
          style={{ color: "#FFF", padding: " 10px" }}
        >
          {"Request Substitute"}
        </h6>
        <a>
          {momentDate(props.fromDate, "DD-MMM-YYYY")} -{" "}
          {momentDate(props.toDate, "DD-MMM-YYYY")}
        </a>
      </div>
      <Form
        action=""
        method="post"
        noValidate
        validated={validated}
        id="substitudeDetails"
        onSubmit={handleFormSubmit}
      >
        {totalDates &&
          totalDates.length > 0 &&
          totalDates.map((item) => {
            return (
              <>
                <h4>
                  {momentDate(item, "DD-MMM-YYYY")} -{" "}
                  {subjectData[item] &&
                    !Array.isArray(subjectData[item]) &&
                    (subjectData[item].holiday_date ? "Holiday" : "")}
                  {subjectData[item] && Array.isArray(subjectData[item])
                    ? "Day Order - " + subjectData[item][0].day_value
                    : ""}
                </h4>
                <table
                  width="100%"
                  align="center"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr style={{ textTransform: "uppercase" }}>
                      <th>
                        <b>Subject</b>
                      </th>
                      <th>
                        <b>Hours</b>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <b>Staff</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjectData[item] &&
                      !Array.isArray(subjectData[item]) &&
                      (subjectData[item].holiday_date ? (
                        <tr>
                          <td colSpan={3}>
                            <h5 style={{ color: "red", textAlign: "center" }}>
                              Holiday
                            </h5>
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={3}>
                            <h5 style={{ color: "red", textAlign: "center" }}>
                              Day Order Not Found (Please contact administrator)
                            </h5>
                          </td>
                        </tr>
                      ))}

                    {subjectData &&
                      subjectData[item] &&
                      Array.isArray(subjectData[item]) &&
                      subjectData[item].map((items, index) => (
                        <>
                          <tr>
                            <td width="40%">
                              {items.holiday_date}{" "}
                              <input
                                type="hidden"
                                name={"subject[" + j + "][]"}
                                value={items.subject_name}
                              />
                              <input
                                type="hidden"
                                name={"dayorder[" + j + "][]"}
                                value={items.day_value}
                              />
                              <input
                                type="hidden"
                                name={"academic_year[" + j + "][]"}
                                value={items.academic_year}
                              />
                              <input
                                type="hidden"
                                name={"college_year[" + j + "][]"}
                                value={items.college_year}
                              />
                              <input
                                type="hidden"
                                name={"course[" + j + "][]"}
                                value={items.course}
                              />
                              <input
                                type="hidden"
                                name={"coursetype[" + j + "][]"}
                                value={items.coursetype}
                              />
                              <input
                                type="hidden"
                                name={"semester[" + j + "][]"}
                                value={items.semester}
                              />
                              <input
                                type="hidden"
                                name={"subject_id[" + j + "][]"}
                                value={items.subject}
                              />
                              <input
                                type="hidden"
                                name={"section[" + j + "][]"}
                                value={items.section}
                              />
                              <input
                                type="hidden"
                                name={"date[" + j + "][]"}
                                value={item}
                              />
                              {items.subject_name}
                            </td>
                            <td width="20%" style={{ padding: "10px" }}>
                              {" "}
                              <input
                                type="hidden"
                                name={"hour[" + j + "][]"}
                                value={items.hour_value}
                              />
                              {items.hour_value}
                            </td>
                            <td width="40%">
                              <Form.Control
                                as="select"
                                className="fw-bold form-select form-select-sm"
                                size="sm"
                                name={"staff[" + j + "][]"}
                                style={{ border: "1px solid #1b18f2" }}
                                id="staff"
                                onChange={(e) =>
                                  updateNextDropdown(e, "staff", "day" + index)
                                }
                              >
                                <option value="">-Staff-</option>
                                <optgroup label="Department Staff">
                                  {items.department_staff.map((item) => {
                                    return (
                                      <option value={item.id}>
                                        {item.emp_name}
                                      </option>
                                    );
                                  })}
                                </optgroup>
                                <optgroup label="Other Department Staff">
                                  {items.other_department_staff.map((item) => {
                                    return (
                                      <option value={item.id}>
                                        {item.emp_name}
                                      </option>
                                    );
                                  })}
                                </optgroup>
                              </Form.Control>
                            </td>
                          </tr>
                          {/*  <Row
                            className="mt-3"
                            style={{ width: "auto" }}
                            id={"day" + index}
                          >
                            <Col
                              md={2}
                              style={{ width: "25.3%", fontWeight: "bold" }}
                            >
                              {items.subject_name}
                            </Col>
                            <Col md={2} style={{ width: "28%" }}>
                              <Form.Control
                                as="select"
                                className="fw-bold form-select form-select-sm"
                                size="sm"
                                name={"hours[" + j + "][]"}
                                style={{ border: "1px solid #1b18f2" }}
                                id="hours"
                                onChange={(e) =>
                                  updateNextDropdown(e, "hours", "day" + index)
                                }
                              >
                                <option value={items.hour_value}>
                                  {"Hour " + items.hour_value}
                                </option>
                              </Form.Control>
                            </Col>

                            <Col md={3} style={{ width: "45.3%" }}>
                              <Form.Control
                                as="select"
                                className="fw-bold form-select form-select-sm"
                                size="sm"
                                name={"staff[" + j + "][]"}
                                style={{ border: "1px solid #1b18f2" }}
                                id="staff"
                                onChange={(e) =>
                                  updateNextDropdown(e, "staff", "day" + index)
                                }
                              >
                                <option value="">-Staff-</option>
                                <optgroup label="Department Staff">
                                  {items.department_staff.map((item) => {
                                    return (
                                      <option value={item.id}>
                                        {item.emp_name}
                                      </option>
                                    );
                                  })}
                                </optgroup>
                                <optgroup label="Other Department Staff">
                                  {items.other_department_staff.map((item) => {
                                    return (
                                      <option value={item.id}>
                                        {item.emp_name}
                                      </option>
                                    );
                                  })}
                                </optgroup>
                              </Form.Control>
                            </Col>

                            {/*  <Col md={2} style={{ width: "33.3%" }} className="mt-3">
                        <Button
                          type="button"
                          variant="danger"
                          className="btn btn-block "
                          onClick={(e) => handleRemoveField(index)}
                        >
                          Remove
                        </Button>
                      </Col> *
                          </Row> */}
                        </>
                      ))}
                  </tbody>
                </table>
                <span style={{ display: "none" }}>
                  {" "}
                  {subjectData[item] && !Array.isArray(subjectData[item])
                    ? subjectData[item].holiday_date
                      ? ""
                      : j++
                    : j++}
                </span>
              </>
            );
          })}

        <Row className="mt-2" style={{ width: "auto" }}>
          {" "}
          <Button type="submit" variant="primary" className="btn btn-block ">
            Save
          </Button>
        </Row>
      </Form>
    </>
  );
};
export default LeaveSubstitute;
